import { Create, SimpleForm, useGetIdentity } from "react-admin";
import { UserForm } from "./UserForm";
import { useCreateSubmit } from "../../forms";

export const UserCreate = () => {
	const { data: userIdentity } = useGetIdentity();

	return (
		<Create>
			<SimpleForm onSubmit={useCreateSubmit("users", "User created")}>
				<UserForm showAdminField={userIdentity?.admin} />
			</SimpleForm>
		</Create>
	);
};
